import moment from "moment";
import { Table } from "antd";
import { CSVLink } from "react-csv";
import { useEffect, useState } from "react";
import CardOverTimeTable from "../../../components/Card/CardOverTimeTable";
import useWorkingHourTable from "../../../hooks/WorkingHourTable";
import download from "../../../assets/icons/download_blue.svg";
import useDownloadButton from "./hooks/useDownloadButton";
import useYear from "../../../hooks/Year";


const DowloadingProjects = () => {
    const { listOfYears, year, updateYear } = useYear();
    const { columns, projects, updateProjects, isLoading } = useWorkingHourTable();
    const { formatProjectDownloaded } = useDownloadButton(projects);
    const [filteredProjects, setFilteredProjects] = useState([])

    useEffect(() => {
        updateProjects(year);
    }, [updateProjects, year]);

    useEffect(() => {
        setFilteredProjects(() => {
            return formatProjectDownloaded(projects);
        })
    }, [formatProjectDownloaded, projects])

    return (
        <section style={{ height: "calc(100vh - 64px)" }} className="w-full py-8 px-6 bg-[#f5f5f5]">
            <CardOverTimeTable
                title={"Tabla de horas de proyecto"}
                listValues={listOfYears}
                currentValue={year}
                updateValue={updateYear}
                numberOfProjects={projects.length}
                downloadButton={
                    <CSVLink
                        filename={`proyectos-horas-${moment(new Date()).format("DD/MM/yyyy")}`}
                        data={filteredProjects}
                        className="active:scale-105 duration-300"
                    >
                        <div className="w-full h-full flex  gap-1 justify-center items-center px-2 py-2 rounded-md  lg:w-full lg:max-w-[328px] lg:justify-self-end  active:scale-105 duration-300 download-button">
                            <img src={download} alt="dowload" className="w-4 h-full m-auto " />
                            <p className="text-[11px] font-bold leading-normal text-[#1677ff]">Descargar toda la tabla</p>
                        </div>
                    </CSVLink>
                }
            >
                <Table
                    loading={isLoading}
                    key={1000}
                    width={2000}
                    style={{ fontSize: 12 }}
                    pagination={false}
                    columns={columns}
                    dataSource={projects}
                    onChange={(dta, filters) => {
                        if (filters === null) return setFilteredProjects(projects);
                        const { size, status } = filters;

                        setFilteredProjects(() => {
                            return projects.filter(project => {
                                const isStatus = status ? status.includes(project.status) : true;
                                const isSize = size ? size.includes(project.size) : true;

                                return isSize && isStatus
                            });
                        })



                    }}
                    scroll={{
                        x: 2900,
                        y: 1200,
                    }}
                    sticky={{
                        offsetHeader: 0,
                    }}
                />
            </CardOverTimeTable>
        </section>
    );
};

export default DowloadingProjects;
